import { ThemeOptions, buttonClasses, buttonGroupClasses } from '@mui/material';

import { capitalDesignTokens } from '../../capital_design_tokens';

export const MuiButtonGroup: ThemeOptions['components']['MuiButtonGroup'] = {
  defaultProps: {
    disableElevation: true
  },
  styleOverrides: {
    root: ({ theme }) => {
      return {
        // For contained buttons
        [`&.${buttonGroupClasses.contained} > .${buttonGroupClasses.grouped}.${buttonClasses.contained}.${buttonClasses.colorPrimary}`]:
          {
            borderColor: theme.palette.common.white,
            '&:hover': {
              background: theme.palette.primary.dark
            },
            '&:disabled': {
              opacity: '0.6',
              borderColor: theme.palette.common.white
            }
          },

        // For text buttons
        [`&.${buttonGroupClasses.text} > .${buttonGroupClasses.grouped}.${buttonClasses.text}`]: {
          borderColor: 'transparent',
          '&:hover': {
            background: theme.palette.action.hover
          },
          '&:disabled': {
            opacity: '0.6',
            background: 'transparent',
            borderColor: 'transparent'
          }
        },

        // For outlined buttons
        [`&.${buttonGroupClasses.outlined} > .${buttonGroupClasses.grouped}.${buttonClasses.outlined}.${buttonClasses.colorPrimary}`]:
          {
            color: theme.palette.primary.main,
            lineHeight: theme.spacing(1.75),
            '&:hover': {
              background: theme.palette.action.hover
            },
            '&:disabled': {
              opacity: '0.6',
              borderColor: theme.palette.primary.main,
              background: 'transparent'
            }
          },

        // Size styles
        [`& > .${buttonGroupClasses.grouped}.${buttonClasses.sizeMedium}`]: {
          fontSize: capitalDesignTokens.componentFontSizes.medium,
          height: `${capitalDesignTokens.componentSizes.medium}px`,
          minHeight: `${capitalDesignTokens.componentSizes.medium}px`,
          padding: theme.spacing(1.5),
          maxHeight: `${capitalDesignTokens.componentSizes.medium}px`
        },
        [`& > .${buttonGroupClasses.grouped}.${buttonClasses.sizeSmall}`]: {
          fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyXSmall,
          height: `${capitalDesignTokens.componentSizes.small}px`,
          minHeight: `${capitalDesignTokens.componentSizes.small}px`,
          padding: theme.spacing(1),
          maxHeight: `${capitalDesignTokens.componentSizes.small}px`
        },
        [`& > .${buttonGroupClasses.grouped}.${buttonClasses.sizeLarge}`]: {
          fontSize: capitalDesignTokens.componentFontSizes.large,
          height: `${capitalDesignTokens.componentSizes.large}px`,
          minHeight: `${capitalDesignTokens.componentSizes.large}px`,
          padding: theme.spacing(1.5),
          maxHeight: `${capitalDesignTokens.componentSizes.large}px`
        },

        '& > .MuiButtonGroup-grouped .MuiSvgIcon-root + .MuiButtonLabel': {
          paddingLeft: theme.spacing(0.5)
        }
      };
    }
  }
};
